import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getAdminApi } from '../api/usersApi';

import logo from '../assets/images/logo.png'
import logoText from '../assets/images/logotext.png'
import icon_logout from '../assets/images/icon-logout.png'
import home from '../assets/images/sidebar-icon/home.png'
import accelerators from '../assets/images/sidebar-icon/accelerators.png'
import analytics from '../assets/images/sidebar-icon/analytics.png'
import angels from '../assets/images/sidebar-icon/angels.png'
import founders from '../assets/images/sidebar-icon/founders.png'
import reports from '../assets/images/sidebar-icon/reports.png'
import settings from '../assets/images/sidebar-icon/settings.png'
import transactions from '../assets/images/sidebar-icon/transactions.png'
import vcs from '../assets/images/sidebar-icon/vcs.png'
import profileImage from '../assets/images/Avatar.png'

import '../assets/css/Header.css'

const Header = (props) => {

    const [isHovered, setIsHovered] = useState(false);
    const existingCookie = Cookies.get('userData');
    let userData = existingCookie ? JSON.parse(existingCookie) : {};

    const sidebarClasses = `main-sidebar sidebar ${isHovered && "hover-menu"} ${`stickyBar ${props?.menuActive && 'fullStickyBar'}`}`

    const toggleMenu = () => {
        const body = document.body;
        if (props?.menuActive) {
            body.classList.remove('hide-menu');
        } else {
            body.classList.add('hide-menu');
        }
        props?.setMenuActive(!props?.menuActive);
    };

    const handleHamburgerClick = () => {
        toggleMenu();
        setIsHovered(false);
    };

    const handleMouseEnter = () => {
        if (props?.menuActive) {
            setIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const resetMenuActive = () => {
        props?.setMenuActive(false);
        document.body.classList.remove('hide-menu');
    };

    const handleMenuItemClick = (e, url) => {
        if (props?.isContentChange === true) {
            e.preventDefault();
            props?.showConfirmationPopup(url);
        } else {
            resetMenuActive();
        }
    };

    const handleLogout = (e) => {
        Cookies.remove('rememberMe')
        Cookies.remove('admin_token')
        Cookies.remove('userData')
        window.location.href = '/sign-in'
    }

    return (
        <div className={sidebarClasses} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="logo-hamburger-menu mobile-view">
                <Link className='logotype' to={'/'}>
                    <img src={logo} alt="Persone" className='logo-icon' />
                    <span><img src={logoText} alt="Persone" className='logo-text' /></span>
                </Link>
                <div className='mobile-menuRight'>
                    <button className='hamburger-menu' onClick={() => handleHamburgerClick()}>
                        <span></span>
                    </button>
                </div>
            </div>
            <nav id="myNav">
                <div className="menuWrapper">
                    <div className="logo-hamburger-menu desktop-view">
                        <Link className="logotype" to={"/"}>
                            <img src={logo} alt="Persone" className='logo-icon' />
                            <span><img src={logoText} alt="Persone" className='logo-text' /></span>
                        </Link>
                        <button className="hamburger-menu" onClick={() => handleHamburgerClick()}>
                            <span></span>
                        </button>
                    </div>
                    <div className="menu-wrapperBox">
                        <ul className="menuList">
                            <li>
                                <Link className={(props?.activePage === 'dashboard') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/" onClick={(e) => { handleMenuItemClick(e, '/') }}>
                                    <img src={home} className="home-icon" alt="home-icon" />
                                    <span>Home</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'founders') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/founders" onClick={(e) => { handleMenuItemClick(e, '/founders') }}>
                                    <img src={founders} className="home-icon" alt="founder-icon" />
                                    <span>Founders</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'angels') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/angels" onClick={(e) => { handleMenuItemClick(e, '/angels') }}>
                                    <img src={angels} className="home-icon" alt="angels-icon" />
                                    <span>Angels</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'vcs') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/vcs" onClick={(e) => { handleMenuItemClick(e, '/vcs') }}>
                                    <img src={vcs} className="home-icon" alt="vcs-icon" />
                                    <span>VCs</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'accelerators') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/accelerators" onClick={(e) => { handleMenuItemClick(e, '/accelerators') }}>
                                    <img src={accelerators} className="home-icon" alt="accelerators-icon" />
                                    <span>Accelerators</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'reports') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/reports" onClick={(e) => { handleMenuItemClick(e, '/reports') }}>
                                    <img src={reports} className="home-icon" alt="reports-icon" />
                                    <span>Reports</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'analytics') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/" >
                                    <img src={analytics} className="home-icon" alt="analytics-icon" />
                                    <span>Analytics</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'transactions') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/transactions" onClick={(e) => { handleMenuItemClick(e, '/transactions') }}>
                                    <img src={transactions} className="home-icon" alt="transaction-icon" />
                                    <span>Transactions</span>
                                </Link>
                            </li>
                            <li>
                                <Link className={(props?.activePage === 'setting') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/setting" onClick={(e) => { handleMenuItemClick(e, '/setting') }}>
                                    <img src={settings} className="home-icon" alt="setting-icon" />
                                    <span>Settings</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="user-action">
                        <div className="menuRight">
                            <div className="userProfile">
                                <div className={`avatarVisible ${'userInfoActive' === true ? "active" : ""}`} >
                                    <div className="sidebar-user">
                                        <img className="avatar" src={userData?.profileImg} alt="Avatar" />
                                    </div>
                                    <div className="sidebar-user-content">
                                        <p className="sidebar-user-name">
                                            {userData?.name} {userData?.lastName}
                                        </p>
                                        <p className="sidebar-user-mail">
                                            {userData?.email}
                                        </p>
                                    </div>
                                </div>
                                <div className="sidebar-logout" onClick={() => handleLogout()}>
                                    <img className="icon-logout" src={icon_logout} alt="icon-logout" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Header
